import { FunctionComponent, useCallback } from "react";
import { ActionButton } from "@ui-kit/ActionButton/ActionButton";
import { ExternalLinkIcon } from "@icons/ExternalLinkIcon";
import { useTranslation } from "react-i18next";
import { createAnalyticsEvent } from "@lib/analytics";
import { Event } from "@dto/Event";
import { Place } from "@dto/Place";
import { Goal } from "@dto/Goal";
import { Tour } from "@dto/Tour";
import { eventNames } from "@lib/analyticsEventNames";
import { selectIsWebsitesEnabled } from "@store/client/clientReducer";
import { useAppSelector } from "@store/store";

interface WebSiteActionButtonProps {
  website: string;
  entity: Event | Place | Goal | Tour;
}

const WebsiteActionButton: FunctionComponent<WebSiteActionButtonProps> = ({
  website,
  entity,
}) => {
  const { t } = useTranslation();
  const isWebsitesEnabled = useAppSelector(selectIsWebsitesEnabled);

  const handlePress = useCallback(() => {
    createAnalyticsEvent(eventNames.websitePressed, {
      id: entity.id,
      name: entity.name,
      type: entity.type,
    });
  }, [entity]);

  if (!isWebsitesEnabled) {
    return null;
  }

  return (
    <ActionButton
      testID="website-action"
      label={t("entity.websiteLabel")}
      icon={<ExternalLinkIcon />}
      href={website}
      onPress={handlePress}
      target="_blank">
      {t("common.website")}
    </ActionButton>
  );
};

export { WebsiteActionButton };
